document.addEventListener('DOMContentLoaded', () => {
  const infoWrapper = document.querySelector('.product-info-wrapper');
  const stickyWrapper = document.querySelector('.product-sticky-details-wrapper');

  if (!infoWrapper || !stickyWrapper) {
    return;
  }

  const handleScroll = () => {
    if (window.innerWidth < 990) { // Only on desktop
      stickyWrapper.classList.remove('is-sticky');
      return;
    }

    const infoBottom = infoWrapper.getBoundingClientRect().bottom;

    if (infoBottom < 20) { // 20 is the 'top' value from CSS
      stickyWrapper.classList.add('is-sticky');
    } else {
      stickyWrapper.classList.remove('is-sticky');
    }
  };

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
});

